import type { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";
import {
  BackgroundColor,
  BlockContentValue
} from "@silversea-ssc/ui-components-react";
import { BlockContent } from "components/BlockContent";
import ExpiresOnChip from "components/ExpiresOnChip/ExpiresOnChip";
import React, { useMemo } from "react";

type Props = {
  farePricesValidUntilDate: Date | undefined;
  farePricesMayIncreaseOnDate: Date | undefined;
  content: BlockContentValue | undefined;
  className?: string;
  backgroundColor: BackgroundColor;
};

const PricesValidUntilChip: React.FC<Props> = ({
  content,
  farePricesMayIncreaseOnDate,
  farePricesValidUntilDate,
  className,
  backgroundColor
}) => {
  const tokens = useMemo(
    (): TokenValues => ({
      ...(farePricesValidUntilDate
        ? {
            formattedPricesValidUntilDate: {
              type: "date",
              tokenName: "formattedPricesValidUntilDate",
              date: farePricesValidUntilDate as unknown as string
            }
          }
        : {}),
      ...(farePricesMayIncreaseOnDate
        ? {
            formattedPricesMayIncreaseOnDate: {
              type: "date",
              tokenName: "formattedPricesMayIncreaseOnDate",
              date: farePricesMayIncreaseOnDate as unknown as string
            }
          }
        : {})
    }),
    [farePricesValidUntilDate, farePricesMayIncreaseOnDate]
  );

  return (
    <ExpiresOnChip background={backgroundColor} className={className}>
      <BlockContent value={content} tokens={tokens} />
    </ExpiresOnChip>
  );
};

export default PricesValidUntilChip;
